import React, { useCallback, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../services/api';
import { gamesService } from '../services/games.service';
import './Games.css';

export default function Games() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const sendIntranetInit = useCallback(() => {
    if (!iframeRef.current || !user) return;
    const win = iframeRef.current.contentWindow;
    if (!win) return;
    win.postMessage(
      {
        type: 'INTRANET_INIT',
        apiBase: API_BASE_URL,
        user: {
          id: user.id,
          fullName: user.fullName,
          profilePicture: user.profilePicture || '',
        },
      },
      window.location.origin
    );
  }, [user]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !user) return;
    const onLoad = () => sendIntranetInit();
    iframe.addEventListener('load', onLoad);
    if (iframe.contentWindow?.document.readyState === 'complete') onLoad();
    return () => iframe.removeEventListener('load', onLoad);
  }, [user, sendIntranetInit]);

  // Let the game iframe request leaderboard via parent so the auth cookie is sent
  useEffect(() => {
    const handler = async (e: MessageEvent) => {
      if (e.origin !== window.location.origin || e.source !== iframeRef.current?.contentWindow) return;
      if (e.data?.type !== 'intranetGetLeaderboard') return;
      try {
        const list = await gamesService.getLeaderboard();
        (e.source as Window).postMessage({ type: 'intranetLeaderboardData', list }, e.origin);
      } catch {
        (e.source as Window).postMessage({ type: 'intranetLeaderboardError' }, e.origin);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  return (
    <div className="games-page">
      <header className="games-header">
        <button type="button" className="games-back" onClick={() => navigate('/')} aria-label="Back to dashboard">
          ← Back to Intranet
        </button>
        <h1 className="games-title">අලුත් අවුරුදු ක්‍රීඩා</h1>
      </header>
      <div className="games-iframe-wrap">
        <iframe
          ref={iframeRef}
          src="/avurudu-games/index.html?intranet=1"
          title="Avurudu Games"
          className="games-iframe"
        />
      </div>
    </div>
  );
}
